<template>
  <div id="app">
    <router-view /> <!-- Router bileşenini buraya ekleyin -->
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* Stil ayarları buraya eklenebilir */
</style>
